import Swiper, { Autoplay, Navigation, EffectCreative } from 'swiper';
import { swiperObserver } from '../../utils/swiper.utils.js';

let sectorsSwiperWr = document.querySelectorAll('.sectors-swiper-wr');

sectorsSwiperWr.forEach((el) => {
  if (el) {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');
    let slidesCount = el.querySelectorAll('.swiper-slide').length;
    let wrapper = swiperEl.querySelector('.swiper-wrapper');

    let isInitial2Slide = slidesCount === 3 && window.innerWidth >= 1024;

    let autoplay = {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: window.innerWidth >= 1033,
    }

    if(isInitial2Slide) {
      autoplay = false;
    }

    let swiper = new Swiper(swiperEl, {
      modules: [Autoplay, Navigation, EffectCreative],
      observer: true,
      observeParents: true,
      effect: 'creative',
      spaceBetween: 0,
      slidesPerView: 'auto',
      threshold: 10,
      centeredSlides: true,
      initialSlide: slidesCount >= 3 ? 1 : 0,
      allowTouchMove: !isInitial2Slide,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      creativeEffect: {
        prev: {
          translate: ['-102%', 60, -100],
          rotate: [0, 0, -7.59],
          origin: 'right center',
        },
        next: {
          translate: ['102%', 60, -100],
          rotate: [0, 0, 7.59],
          origin: 'left center',
        },
        limitProgress: 2,
      },
      autoplay: autoplay
    });

    if(!isInitial2Slide) {
      swiperObserver(swiper);
    }
  }
});